/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.16.0
 * @since 1.13.0
 */

import styled from 'styled-components';

import { icons } from '../../../../../../assets';
import { ImgStyled } from '../../../../../../components/common/Block/Img';
import { FormBlockStyled, FormLabelStyled } from '../../../../../../components/common/FormStyled/FormStyled';
import { colors } from '../../../../../../theme';

export const SubscriberInfoDataInfoStyled = styled.div.attrs({
    className: 'personal-data__info',
})`
    display: flex;
    flex-direction: column;

    .personal-data__block {
        display: grid;
        grid-template-columns: 50% 50%;
        column-gap: 32px;
        margin-bottom: 32px;

        .personal-data__title,
        .personal-data__block-file {
            grid-column: 1 / 3;
        }

        .personal-data__title {
            grid-column: 1 / 3;
            margin-bottom: 12px;
        }
    }

    .personal-data__group {
        margin-bottom: 12px;

        &.personal-data__group_email {
            grid-column: 2 / 3;
            .subscriber-id__title_light {
                display: flex;
                align-items: center;

                ${ImgStyled} {
                    margin-left: 12px;
                }
            }
        }
    }

    .personal-data__btn-container {
        display: flex;
        align-items: baseline;
        flex-wrap: wrap;
    }

    .personal-data__btn:not(:last-of-type) {
        margin-right: 16px;
        margin-bottom: 16px;
    }
`;


export const SubscriberInfoDataInfoEditFormStyled = styled.div.attrs({
    className: 'edit-form',
})`
    .edit-form__personal-data {
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 24px
    }

    .edit-form__personal-data,
    .edit-form__address,
    .edit-form__document,
    .edit-form__national-info {
        &:not(:last-child) {
            margin-bottom: 24px;
        }
    }

    .edit-form__address,
    .edit-form__document,
    .edit-form__national-info {
        width: 50%;
        padding-right: 12px;
    }

    .edit-form__address-filed,
    .edit-form__national-info {
        display: flex;
        align-items: center;

        ${FormBlockStyled} {
            flex-grow: 1;
        }
    }

    .drop-down-filter__content {
        width: inherit;
    }


    ${FormLabelStyled} {
        margin-bottom: 4px;
    }
`;

export const SubscriberInfoDataInfoFieldFileStyled = styled.div`
    ${FormLabelStyled} {
        display: flex;
    }

    ${ImgStyled} {
        margin-left: 4px;
    }
`;


export const PersonalDataEditFileStyled = styled.div.attrs({
    className: 'edit-form-file',
})`
    .edit-form-file__btn {
        margin-right: 4px;
    }

    .edit-form-file__list,
    .edit-form-file__error {
        margin-top: 12px;
    }

    .edit-form-file__error {
        color: ${colors.textColorDanger};
    }

    .edit-form-file__item {
        display: flex;
        align-items: center;

        .edit-form-file__name,
        .edit-form-file__extension {
            margin-right: 12px;
        }

        .edit-form-file__name {
            display: flex;
            align-items: center;
        }
    }
`;

export const PersonalDataEditFileRemoveIconStyled = styled(ImgStyled).attrs({
    'className': 'edit-form-file__remove medium pointer',
    'data-name': 'edit-form-file-remove',
})`
    background: url(${icons.removeSmallOpacityIcon}) no-repeat center center;

    &:hover {
        background: url(${icons.removeSmallIcon}) no-repeat center center;
    }

`;

export const SubscriberInfoDataEmailFieldStyled = styled(ImgStyled)`
    display: flex;
    align-items: center;

    ${ImgStyled} {
        height: 32px;
        margin-left: 12px;
    }
`;
